module.exports = __webpack_public_path__ + "img/app.adf07a01.svg";